import { useQuery } from '@apollo/client'

import {
  BrandContactsDocument,
  BrandRetailerConnection,
  BrandUserConnection,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
  query BrandContacts($filter: BrandsFilter, $connectedAccountIds: [ID!]) {
    brands(filter: $filter) {
      edges {
        node {
          brandUsers(filter: { role: SALES_REPRESENTATIVE }) {
            edges {
              node {
                id
                displayName
                email
              }
            }
          }
          connectedAccounts(filter: {connectedAccountIds: $connectedAccountIds}) {
            edges {
              buyers {
                id
                name
                email
              }
            }
          }
        }
      }
    }
  }
`

export const useBrandContacts = (
  brandId: string,
  skip = false,
  retailerId?: string,
) => {
  const { data, loading } = useQuery(BrandContactsDocument, {
    client: atlasClient,
    variables: {
      filter: {
        brandIds: [brandId],
      },
      ...(retailerId && { connectedAccountIds: [retailerId] }),
    },
    skip,
  })

  const brand = data?.brands?.edges?.[0]?.node

  const brandBuyers = brand?.connectedAccounts as BrandRetailerConnection

  const brandSalesReps = brand?.brandUsers as BrandUserConnection

  return { brandBuyers, brandSalesReps, loading }
}
